<div class="d-flex align-items-center justify-content-center mb-5" *ngIf="data">
  <div class="d-flex flex-column flex-md-row">
    <!--    ULTIMI 10 MEDICINALI AUTORIZZATI-->
    <div class="me-md-3">
      <div
        class="card text-center    rounded p-2 topten-header-card"
      >
        <h4
          class="text-black my-3"
          i18n="
            topten title medicines|Search page
            @@serach-page.title-text.topten-medicines"
        >
          Ultimi 10 medicinali autorizzati
        </h4>
      </div>

      <div
        class="p-2 border rounded my-2 d-flex flex-column topten-card"
        *ngFor="let medicinale of data.medicinali"
      >
        <p class="mb-0  text-secondary topten-name-p "> 
          {{ medicinale.nome }}
        </p>
        <p class="m-0 text-black  text-capitalize">
          {{ medicinale.nomeTitolare | titlecase }}
        </p>
        <p class="m-0 text-black small mb-0 align-self-end" i18n="
        topten data package|Search page
        @@serach-page.data-text.topten-package">
          Data: {{ medicinale.data | date:'dd/MM/yyyy' }}
        </p>
      </div>
    </div>
    <!--   FINE ULTIMI 10 MEDICINALI AUTORIZZATI border-start  border-bottom-->

    <!--   ULTIME 10 CONFEZIONIE AUTORIZZATE-->
    <div class="ms-md-3">
      <div
        class="card text-center  rounded p-2 topten-header-card mt-5 mt-md-0"
      >
        <h4
          class="text-black my-3 " 
          i18n="
            topten title package|Search page
            @@serach-page.title-text.topten-package"
        >
          Ultime 10 confezioni autorizzate
        </h4>
      </div>

      <div
        class="p-2 border rounded my-2 d-flex flex-column topten-card"
        *ngFor="let confezione of data.confezioni"
      >
        <p class="m-0  text-secondary topten-name-p">
          {{ confezione.nome  }}
        </p>
        <p class="m-0 text-secondary topten-name-p">
          {{ confezione.nomeConfezione}}
        </p>
        <p class="m-0 text-black  text-capitalize">
          {{ confezione.nomeTitolare | titlecase }}
        </p>
        <p class="m-0 text-black small mb-0 align-self-end" 
        i18n="
            topten data package|Search page
            @@serach-page.data-text.topten-package">
          Data: {{ confezione.data | date:'dd/MM/yyyy' }}
        </p>
      </div>
    </div>
    <!--    FINE ULTIME 10 CONFEZIONIE AUTORIZZATE-->
  </div>
</div>
